module.exports = __webpack_public_path__ + "images/emoji/new_moon_with_face.0fb4ce205f905c0c97b2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/new_moon_with_face.png
// module id = wIfR
// module chunks = 2